import { useState } from "react";
import PropTypes from "prop-types";
import { IconButton, TextField, Tooltip } from "@mui/material";
import { UndoIcon } from "src/components/icons/ActionIcons";

export default function FPTilauksetSuodataTextBox(props) {
  const disabled = props.disabled || false;
  const [suodata, setSuodata] = useState("");

  const handleChange = (e) => {
    setSuodata(e.target.value);
    props.setSuodata(e.target.value);
  };

  const handleUndoClick = () => {
    setSuodata("");
    props.setSuodata("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setSuodata("");
      props.setSuodata("");
    }
  };

  return (
    <TextField
      sx={{ width: "100%" }}
      aria-label="Suodata / etsi"
      aria-describedby="outlined-basic_filter"
      disabled={disabled}
      onKeyDown={handleKeyDown}
      id="outlined-basic_filter"
      label="Suodata / etsi"
      variant="outlined"
      onChange={handleChange}
      value={suodata}
      autoComplete="off"
      type="text"
      inputProps={{
        autoComplete: "new-password",
        form: { autocomplete: "off" },
        style: { fontSize: "16px", height: "100%", width: "150px" },
      }}
      InputProps={{
        endAdornment: (
          <div style={{ visibility: suodata.length > 0 ? "inherit" : "hidden" }}>
            <Tooltip disableInteractive title="Tyhjennä" placement="right" arrow>
              <IconButton onClick={handleUndoClick}>
                <UndoIcon />
              </IconButton>
            </Tooltip>
          </div>
        ),
      }}
    />
  );
}

FPTilauksetSuodataTextBox.propTypes = {
  setSuodata: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
